import React, { useState } from 'react';

import { InputLabelHorizontal } from 'components/RabbitInitiativeCreationPanel/components/InputLabelHorizontal';
import { InitiativeDescriptionComp } from 'components/RabbitInitiativeSidePanel/PrimaryPanel/Sections/Details/InitiativeDescription';

import { Plus } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';

const InitiativeCreationDescription = ({ description, onChange }) => {
  const [showDescription, setShowDescription] = useState(false);

  return (
    <InputLabelHorizontal
      labelText="Description:"
      containerProps={isMobileView() ? { gridTemplateColumns: '80px 1fr' } : { gridTemplateColumns: '120px 1fr' }}
    >
      {showDescription ? (
        <InitiativeDescriptionComp description={description} onChange={onChange} />
      ) : (
        <Button variant="tertiary" StartIcon={Plus} color="blue" onClick={() => setShowDescription(true)}>
          Add Description
        </Button>
      )}
    </InputLabelHorizontal>
  );
};

export default InitiativeCreationDescription;
